module.exports = {
          srcSet: __webpack_public_path__ + "44aef46e5cec09554696aa55d7f7a178-1680.png"+" 1680w",
          images:[ {path: __webpack_public_path__ + "44aef46e5cec09554696aa55d7f7a178-1680.png",width: 1680,height: 803}],
          src: __webpack_public_path__ + "44aef46e5cec09554696aa55d7f7a178-1680.png",
          toString:function(){return __webpack_public_path__ + "44aef46e5cec09554696aa55d7f7a178-1680.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAFCAYAAAB8ZH1oAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAWElEQVR4nJXNQQpFYAAE4C/ZKCVxAQuuo94VsJB6b2NvLwtHltevLGxMTVMz0wwvEKFGjgwVSjT4Yr6KKTa0WLCHcMWE/r76wYAfRnShXDzdJ0FPxjf/jwPrqwfW7t5VJQAAAABJRU5ErkJggg==",
          width: 1680,
          height: 803
        }